document.querySelectorAll('.section-video').forEach((wrap) => {
  const video = wrap.querySelector('.section-video video');
  const play = wrap.querySelector('.section-video__play');
  // Play/Pause
  const playPauseVideo = () => {
    if (video.paused) {
      play.setAttribute('data-icon', 'pause');
      video.play();
    } else {
      play.setAttribute('data-icon', 'play');
      video.pause();
    }
  };
  if (play) play.addEventListener('click', playPauseVideo);
});

// Video overlay
const bodyOverlayVisible = 'body--overlay-visible';
const overlayVisible = 'section-video__overlay--visible';
const videoButtons = document.querySelectorAll('.js-open-video-overlay');
const videoOverlays = document.querySelectorAll('.section-video__overlay');

if (videoButtons && videoOverlays) {
  const { body } = document;
  const closeButtons = document.querySelectorAll('.section-video__overlay__close');
  const overlayBodies = document.querySelectorAll('.section-video__overlay__content');

  videoButtons.forEach((button, index) => {
    const videoFrame = overlayBodies[index].querySelector('.figure__video');
    const videoSrc = videoFrame.src;
    videoFrame.src = '';

    button.addEventListener('click', (event) => {
      videoOverlays[index].classList.add(overlayVisible);
      body.classList.add(bodyOverlayVisible);

      if (!videoFrame.src || !videoFrame.src.includes(videoSrc)) {
        videoFrame.src = `${videoSrc}&autoplay=1`;
      }


      event.stopPropagation();
      return false;
    });

    closeButtons[index].addEventListener('click', () => {
      videoOverlays[index].classList.remove(overlayVisible);
      body.classList.remove(bodyOverlayVisible);
      videoFrame.src = '';
    });

    document.addEventListener('click', (event) => {
      const isClickInside = overlayBodies[index].contains(event.target);
      if (!isClickInside) {
        videoOverlays[index].classList.remove(overlayVisible);
        body.classList.remove(bodyOverlayVisible);

        videoFrame.src = '';
      }
    });
  });
}
